import React from 'react'
import images from '../../Asset/Img/img'
import "./Form.css"

function Form() {
  return (
    <div className='form-container'>
      <h3>Bize Ulaşın</h3>
      <input type="text" name="" id="" placeholder='İsminiz' />
      <input type="email" name="" id="" placeholder='E-Posta Adresiniz' />
      <textarea name="" id="" placeholder='Mesajınız'></textarea>
      <button><img src={images.sendIcon} alt="send-icon" />Gönder</button>
    </div>
  )
}

export default Form